import { useState, useEffect, Fragment } from "react";

import PropTypes from "prop-types";

import { getDeliverySlots } from "../../../../services/order";

import Modal from "../Modal";
import Loading from "../../Loading/Loading";
import ErrorMessage from "../../Error/ErrorMessage/ErrorMessage";
import Price from "../../../Price/Price";
import Button from "../../button/Button";
import DeliverySlot from "./delivery-slot/DeliverySlot";

import classes from "./DeliveryDateSelectionModal.module.css";

export default function DeliveryDateSelectionModal(props) {
  const {
    isOpen,
    onClose,
    branchId,
    skus,
    bundles,
    onSelectDeliverySlot,
    selectedDeliverySlot,
    onConfirm,
    total,
    isSubmitOrderLoading,
    submitOrderError,
  } = props;

  const [deliveryDate, setDeliveryDate] = useState();
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [dataLoadingError, setDataLoadingError] = useState("");

  useEffect(() => {
    async function fetchDeliveryDates() {
      setIsDataLoading(true);
      const requestData = { branchId, skuList: skus, bundleList: bundles };
      try {
        const res = await getDeliverySlots(requestData);
        const { data } = res;
        setDeliveryDate(data);
      } catch (err) {
        setDataLoadingError("لا توجد بيانات");
      } finally {
        setIsDataLoading(false);
      }
    }

    fetchDeliveryDates();
  }, [branchId, skus, bundles]);

  let deliveryDateContent;

  if (isDataLoading) {
    deliveryDateContent = (
      <Loading className={classes["delivery-slot-modal__loading"]} />
    );
  } else if (dataLoadingError) {
    deliveryDateContent = (
      <ErrorMessage
        className={classes["delivery-slot-modal__error"]}
        message={dataLoadingError}
      />
    );
  } else {
    deliveryDateContent = (
      <div className={classes["delivery-slot-modal__slots-container"]}>
        {deliveryDate.expressDelivery && (
          <div className={classes["delivery-slot-modal__express"]}>
            <ul>
              <DeliverySlot
                name="express"
                slot={{
                  from: deliveryDate.expressDelivery.from,
                  to: deliveryDate.expressDelivery.to,
                }}
                slotText={
                  <>
                    في أقرب وقت
                    <span className="text-primary inline-block mx-2">
                      <span className="ml-2">
                        {new Date(
                          deliveryDate.expressDelivery.from
                        ).toLocaleDateString("ar", { weekday: "long" })}
                      </span>
                      <span className="numeric-content">
                        {new Date(
                          deliveryDate.expressDelivery.from
                        ).toLocaleDateString("ar", {
                          day: "numeric",
                          month: "numeric",
                        })}
                      </span>
                    </span>
                  </>
                }
                selectedSlot={selectedDeliverySlot}
                onSelect={onSelectDeliverySlot}
              />
            </ul>
            <p className={classes["delivery-slot-modal__express-fees"]}>
              يرجي العلم أن مصاريف الشحن{" "}
              <span className="numeric-content">
                {deliveryDate.expressDelivery.fees}
              </span>{" "}
              جنيه
            </p>
          </div>
        )}
        <div className={classes["delivery-slot-modal__scheduled"]}>
          {deliveryDate?.expressDelivery && (
            <h2 className={classes["delivery-slot-modal__scheduled-header"]}>
              تحديد ميعاد آخر
            </h2>
          )}
          <ul className={classes["delivery-slot-modal__scheduled-days"]}>
            {deliveryDate.scheduledDelivery.map((date, index) => (
              <li
                key={index}
                className={classes["delivery-slot-modal__scheduled-day"]}
              >
                <h2
                  className={
                    classes["delivery-slot-modal__scheduled-day-header"]
                  }
                >
                  {date.day}
                </h2>
                <ul
                  className={
                    classes["delivery-slot-modal__scheduled-day-slots"]
                  }
                >
                  {date.slots.map((slot, index) => (
                    <DeliverySlot
                      key={index}
                      name="scheduled"
                      slot={slot}
                      selectedSlot={selectedDeliverySlot}
                      onSelect={onSelectDeliverySlot}
                    />
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="ميعاد التوصيل"
      footer={
        <div className={classes["delivery-slot-modal__footer"]}>
          <div className={classes["delivery-slot-modal__total-wrapper"]}>
            <p className={classes["delivery-slot-modal__total-text"]}>
              الإجمالي
            </p>
            <div className={classes["delivery-slot-modal__total-value"]}>
              <Price value={total} suffix="جم" />
              {selectedDeliverySlot?.isExpressDelivery && (
                <Fragment>
                  +
                  <Price
                    className={classes["delivery-slot-modal__fees"]}
                    value={deliveryDate?.expressDelivery.fees}
                    suffix="جم"
                  />
                  =
                  <Price
                    value={total + deliveryDate?.expressDelivery.fees}
                    suffix="جم"
                  />
                </Fragment>
              )}
            </div>
          </div>
          <div>
            <Button
              className={classes["checkout__branches-modal-submit-btn"]}
              type="primary"
              disabled={!selectedDeliverySlot}
              onClick={onConfirm}
              loading={isSubmitOrderLoading}
              withAnimation
            >
              تأكيد عملية الشراء
            </Button>
            {submitOrderError && (
              <ErrorMessage
                message={submitOrderError}
                className={classes["checkout__branches-modal-submit-error"]}
              />
            )}
          </div>
        </div>
      }
    >
      <div className={classes["delivery-slot-modal"]}>
        <header className={classes["delivery-slot-modal__header"]}>
          <h2>الرجاء اختيار ميعاد التوصيل</h2>
        </header>
      </div>
      {deliveryDateContent}
    </Modal>
  );
}

DeliveryDateSelectionModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  branchId: PropTypes.number,
  skus: PropTypes.array,
  bundles: PropTypes.array,
  onSelectDeliverySlot: PropTypes.func,
  selectedDeliverySlot: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
  }),
  onConfirm: PropTypes.func,
  total: PropTypes.number,
  isSubmitOrderLoading: PropTypes.bool,
  submitOrderError: PropTypes.string,
};
